var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid pt-3 px-9"},[(_vm.loading)?_c('placeholder-analytic-kpi'):_c('div',{staticClass:"w-100 h-screen bg-white"},[_c('iframe',{staticClass:"w-100 h-full",staticStyle:{"min-height":"800px"},attrs:{"title":"QuickSight Dashboard","src":_vm.dashboardUrl,"frameborder":"0","allowfullscreen":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }